import moment from 'moment';

export const required = value => (value ? undefined : 'Campo obrigatório');

const validDate = (value, expectedDateFormat, errorMessage) =>
  moment(value, expectedDateFormat).isValid() ? undefined : errorMessage;

export const validInitialDate = value =>
  validDate(value, 'DD/MM/YYYY', 'Data inicial inválida');

export const validFinalDate = value =>
  validDate(value, 'DD/MM/YYYY', 'Data final inválida');

export const validDates = (value, allValues) => {
  if (!allValues.initialDate || !allValues.finalDate) return false;
  if (
    allValues.initialDate.length === 10 &&
    allValues.finalDate.length === 10
  ) {
    const startDate = moment(allValues.initialDate);
    const finalDate = moment(allValues.finalDate);
    const diff = finalDate.diff(startDate);

    if (diff < 0) return 'Data inicial é maior do que a data final';
    if (diff === 0) return 'Data inicial é igual a data final';
  }
  return false;
};

// regex from http://emailregex.com/ (RFC 5322 Official Standard)
export const validEmail = value =>
  value &&
  !/^(([^<>()[\]\\.,:\s@"]+(\.[^<>()[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    value,
  )
    ? 'E-mail inválido'
    : undefined;

export const confirmNewPassword = (value, allValues) =>
  value !== allValues.newPassword ? 'As senhas não conferem' : undefined;

const validRootCNPJ = value => {
  if (!value) return false;

  const cnpj = value.replace(/[^\d]+/g, '');

  if (cnpj === '') return false;

  return cnpj.length === 8;
};

const validateCompleteCNPJ = value => {
  if (!value) return false;

  const cnpj = value.replace(/[^\d]+/g, '');

  if (cnpj === '') return false;

  if (cnpj.length !== 14) return false;

  // Remove known invalid CNPJs
  if (
    cnpj === '00000000000000' ||
    cnpj === '11111111111111' ||
    cnpj === '22222222222222' ||
    cnpj === '33333333333333' ||
    cnpj === '44444444444444' ||
    cnpj === '55555555555555' ||
    cnpj === '66666666666666' ||
    cnpj === '77777777777777' ||
    cnpj === '88888888888888' ||
    cnpj === '99999999999999'
  )
    return false;

  // Validate DVs
  let numberLength = cnpj.length - 2;
  let numberWithoutDigits = cnpj.substring(0, numberLength);
  const digits = cnpj.substring(numberLength);
  let sum = 0;
  let pos = numberLength - 7;
  for (let i = numberLength; i >= 1; i -= 1) {
    sum += numberWithoutDigits.charAt(numberLength - i) * pos;
    pos -= 1;
    if (pos < 2) pos = 9;
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== Number(digits.charAt(0))) return false;

  numberLength += 1;
  numberWithoutDigits = cnpj.substring(0, numberLength);
  sum = 0;
  pos = numberLength - 7;
  for (let i = numberLength; i >= 1; i -= 1) {
    sum += numberWithoutDigits.charAt(numberLength - i) * pos;
    pos -= 1;
    if (pos < 2) pos = 9;
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

  return result === Number(digits.charAt(1));
};

const validateCompleteCPF = (value) => {
  if (!value) return false;

  const cpf = value.replace(/[^\d]/g, '');

  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  let sum = 0, rest;
  for (let i = 1; i <= 9; i++) sum += parseInt(cpf.charAt(i - 1)) * (11 - i);
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;
  if (rest !== parseInt(cpf.charAt(9))) return false;

  sum = 0;
  for (let i = 1; i <= 10; i++) sum += parseInt(cpf.charAt(i - 1)) * (12 - i);
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) rest = 0;
  return rest === parseInt(cpf.charAt(10));
};


export const validRootOrCompleteCNPJAndCPF = value =>
  validRootCNPJ(value) || validateCompleteCNPJ(value) || validateCompleteCPF(value)
    ? undefined
    : 'CNPJ/CPF inválido.';

export const validRootOrCompleteCNPJ = value =>
  validRootCNPJ(value) || validateCompleteCNPJ(value)
    ? undefined
    : 'CNPJ inválido.';

export const validRootOrCompleteCNPJAndCPFAndAllowEmpty = value => {
  if (!value) return undefined;
  return validRootOrCompleteCNPJAndCPF(value);
};

export const validRootOrCompleteCNPJAndAllowEmpty = value => {
  if (!value) return undefined;
  return validRootOrCompleteCNPJ(value);
};

export const minTextLength = minLength => value =>
  value && value.length >= minLength
    ? undefined
    : `Insira um texto de até ${minLength} caracteres.`;

export const isEmptyString = (str) => {
  return /^\s+$/.test(str);
}
